import { Delete } from "@mui/icons-material";
import { lighten, styled, Toolbar, Tooltip, Typography } from "@mui/material";
import clsx from "clsx";
import { StyledButton } from "components/StyledButton";

const PREFIX = "RegisteredTableToolbar";

const classes = {
	root: `${PREFIX}-root`,
	highlight: `${PREFIX}-highlight`,
	title: `${PREFIX}-title`,
	delete: `${PREFIX}-delete`,
};

const StyledToolbar = styled(Toolbar)(({ theme }) => ({
	[`&.${classes.root}`]: {
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(1),
	},

	[`&.${classes.highlight}`]:
		theme.palette.mode === "light"
			? {
					color: theme.palette.secondary.main,
					backgroundColor: lighten(theme.palette.secondary.light, 0.85),
			  }
			: {
					color: theme.palette.text.primary,
					backgroundColor: theme.palette.secondary.dark,
			  },

	[`& .${classes.title}`]: {
		flex: "1 1 100%",
	},

	[`& .${classes.delete}`]: {
		minWidth: 100,
		marginRight: theme.spacing(1),
	},
}));

export interface RegisteredTableToolbarProps {
	/**
	 * Additional toolbar buttons.
	 */
	children?: JSX.Element | JSX.Element[];
	numSelected: number;
	handleDelete: () => void;
	title: string;
}

export const RegisteredTableToolbar = ({
	children,
	numSelected,
	handleDelete,
	title,
}: RegisteredTableToolbarProps): JSX.Element => {
	return (
		<StyledToolbar
			className={clsx(classes.root, {
				[classes.highlight]: numSelected > 0,
			})}
		>
			{numSelected > 0 ? (
				<>
					<Typography
						className={classes.title}
						color="inherit"
						variant="subtitle1"
						component="div"
					>
						{numSelected} selected
					</Typography>
					<Tooltip title="Delete">
						<StyledButton
							data-testid="delete-button"
							onClick={handleDelete}
							aria-label="delete"
							size="medium"
							color="error"
							startIcon={<Delete />}
							variant="outlined"
							className={classes.delete}
						>
							Delete
						</StyledButton>
					</Tooltip>
				</>
			) : (
				<>
					<Typography
						className={classes.title}
						variant="h6"
						id="tableTitle"
						component="div"
					>
						{title}
					</Typography>
				</>
			)}
			{children}
		</StyledToolbar>
	);
};
